








































import Vue from "vue";
import GridView from "@/components/TeamCalendar/GridView.vue";
import TeamCalendarModule from "@/views/Calendar/TeamCalendarModule";
import { getModule } from "vuex-module-decorators";
import CalendarLayoutSelectors from "@/components/TeamCalendar/CalendarLayoutSelectors.vue";
import AddEventMenuButton from "@/components/TeamCalendar/AddEventMenuButton.vue";
import TeamCalendarNav from "@/components/TeamCalendar/TeamCalendarNav.vue";
import TeamCalendarList from "@/components/TeamCalendar/TeamCalendarList.vue";
import { bus } from "@/main";
import { getTeam } from "@/helpers/api";
import { api } from "@/helpers/ApiClient";
import ICalModal from "@/components/Calendar/iCalModal.vue";
import router from "@/router";
import { mapGetters } from "vuex";
import GetterTypes from "@/store/GetterTypes";

export default Vue.extend({
  name: "TeamCalendar",
  metaInfo: {
    title: "Team Calendar"
  },
  components: {
    ICalModal,
    TeamCalendarList,
    TeamCalendarNav,
    AddEventMenuButton,
    CalendarLayoutSelectors,
    GridView
  },
  data() {
    return {
      selectedOrgUnit: null,
      module: getModule(TeamCalendarModule, this.$store)
    };
  },
  mounted() {
    bus.$on("refetchTeam", () => {
      this.module.fetchData(
        this.$route.params.teamId || this.$route.params.orgId
      );
    });
  },
  methods: {
    async handleTeamChange(orgId: string, teamId: string) {
      if (teamId) {
        this.selectedOrgUnit = await getTeam(teamId);
      } else if (orgId) {
        const response = await api.get(
          `/api/v1/organizationTeamSummary/${orgId}`
        );
        this.selectedOrgUnit = response.data;
      } else {
        this.selectedOrgUnit = null;
      }
    },
    viewList() {
      router
        .push({
          query: { view: "list", related: this.$route.query.related }
        })
        .catch(e => {});
    }
  },
  computed: {
    ...mapGetters({
      limitedFunctionality: GetterTypes.GET_ORG_HAS_LIMITED_FUNCTIONALITY
    }),
    view(): string {
      return (this.$route.query.view as string) || "list";
    },
    events(): Event[] {
      const events =
        (this.$route.query.related as string) === "true"
          ? this.module.events
          : this.module.selectedTeamsEvents;

      return events;
    }
  },
  watch: {
    "$route.params": {
      handler: function({ orgId, teamId }) {
        this.module.fetchData(teamId || orgId);
        this.handleTeamChange(orgId, teamId);
      },
      immediate: true
    }
  }
});
